import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState } from '../../../..';

import { ActivationComponent, ActivationComponentProperties } from './activation.component';
import { activateContract, getContractDetailsSuccess } from '../../../contract.actions';

import { contractService } from '@services/ContractService';
import { ContractDetailsViewModel } from '@models/Contract';

export interface ActivationContainerProperties {
  readonly contractId: number;
  readonly saveCallback: Function;
  readonly termStartDate: Date;
  readonly buttonRef: (button: HTMLButtonElement) => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: ActivationContainerProperties
): Partial<ActivationComponentProperties> {
  return {
    termStartDate: ownProps.termStartDate
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: ActivationContainerProperties
): Partial<ActivationComponentProperties> {
  return {
    activateContract: (coeDate: Date) => {
      return dispatch(activateContract(coeDate))
        .then(() => contractService.getContractDetails(ownProps.contractId))
        .then((cdvm: ContractDetailsViewModel) => dispatch(getContractDetailsSuccess(cdvm)))
        .then(() => ownProps.saveCallback());
    },
    buttonRef: ownProps.buttonRef
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const Activation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivationComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/activation/_components/activation.container.ts